import { useState } from 'react';
import ManagerPreview from './ManagerPreview';
import TechnicianPreview from './TechnicianPreview';
import CustomerPreview from './CustomerPreview';
import Dashboard from '../main_components/Dashboard';

function UIPreview({color, button, font, logoUrl, iconUrl, table}) {
    const [ appType, setAppType ] = useState('manager');


    return(
        <div className='w-full'>
            <div className='flex justify-between px-16 bg-gray-300 py-2 mb-4'>
                <div onClick={() => setAppType('manager')} className='text-xs cursor-pointer font-semibold'>Manager</div>
                <div onClick={() => setAppType('technician')} className='text-xs cursor-pointer font-semibold'>Technician</div>
                <div onClick={() => setAppType('customer')} className='text-xs cursor-pointer font-semibold'>Customer</div>
            </div>
            {
                appType === 'manager' && <ManagerPreview color={color} button={button} font={font} logoUrl={logoUrl} iconUrl={iconUrl} table={table}/> ||
                appType === 'technician' && <TechnicianPreview color={color} logoUrl={logoUrl} iconUrl={iconUrl} font={font} /> ||
                appType === 'customer' && <CustomerPreview font={font} />
            }
            {/* <Dashboard /> */}
        </div>
    )
}

export default UIPreview;